export default function mock() {
  global.wx = {
    config: function config() {
      console.log('wx.config');
    },
    ready: function ready(cb) {
      console.log('wx.ready');
      cb();
    },
    error: function error(cb) {
      console.log('wx.error');
      // cb({ errMsg: 'config:fail' });
    },
    // 分享到朋友圈
    onMenuShareTimeline: function onMenuShareTimeline(res) {
      // console.log('share timeline', res);
    },
    // 分享给朋友
    onMenuShareAppMessage: function onMenuShareAppMessage() {},
    // 分享给qq
    onMenuShareQQ: function onMenuShareQQ() {
      console.log('我是qq');
    },
    // 分享给腾讯微博
    onMenuShareWeibo: function onMenuShareWeibo() {},
    // 分享到QQ空间
    onMenuShareQZone: function onMenuShareQZone() {},
    closeWindow: function closeWindow() {},
    chooseImage: function chooseImage(src) {
      console.log('wx.chooseImage invoke');
      src.success({
        sourceType: 'camera',
        localIds: ['http://static.playground.forzoom.tech/meta/hundred/bg1.png']
      });
    },
    uploadImage: function uploadImage(src) {
      console.log('wx.uploadImage invoke');
      src.success({
        serverId: 'serverId'
      });
      // src.fail({
      //     errMsg: 'uploadImage:fail test',
      // });
    },
    previewImage: function previewImage() {
      console.log('wx.previewIamge invoke');
    },
    /**
     * 微信支付
     */
    chooseWXPay: function chooseWXPay(res) {
      res.success({
        errMsg: 'chooseWXPay:ok'
      });
    },
    /**
     * 隐藏按钮
     */
    hideMenuItems: function hideMenuItems() {
      console.log('wx.hideMenuItems');
    },
    /**
     * 显示按钮
     */
    showMenuItems: function showMenuItems() {
      console.log('wx.showMenuItems');
    },
    /**
     * 地理位置
     */
    getLocation: function getLocation(res) {
      res.success({
        longitude: 116.46,
        latitude: 39.92,
        speed: '10km/h',
        accuracy: '10km'
      });
    }
  };
}